import { Component } from "react";
import { Navigate } from "react-router-dom";


class HomePage extends Component {
    render(){

        if (!this.props.userAuth) {
            return <Navigate replace to="/login" />;
          } else {
            return <Navigate replace to="/control" />;
          }

    }
}

export default HomePage;